export const ChatDataType = {
  Date: 1,
  Text: 2,
  DateInput: 3,
  Chips: 4,
};

export const PanelDataType = {
  KeyInfo: "key_info",
  PreWeddingTimeline: "pre_wedding_timeline",
  Timeline: "timeline",
  Budget: "budget",
  EstimatedBudget: "estimated_budget",
  Venues: "recommended_venues",
  ExtraRecommendations: "extra_recommendations",
};

export const PanelDataList = Object.values(PanelDataType);
